import { useBoundStore } from '@Store/useBoundStore';
import { HttpService } from '..';
import type { SaveOwnerBody } from '@Types/owner';
import type { UboResponse } from '@Store/index';

export const saveOwner = async (body: SaveOwnerBody) => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { globalCardFirstName, globalCardLastName, setGlobalCardName, setActiveUboName } =
    useBoundStore.getState().onboardingSlice;

  setActiveUboName(body.customerPersonalInfo.firstName, body.customerPersonalInfo.lastName);

  if (globalCardFirstName || globalCardLastName) {
    body.customerPersonalInfo.cardFirstName = globalCardFirstName || '';
    body.customerPersonalInfo.cardLastName = globalCardLastName || '';
  }

  const {
    customerId,
    customerData: {
      customerBusinessData: { externalId: businessId },
    },
  } = useBoundStore.getState().customer;

  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/business/${businessId}/ubo`
    : `v2/secureonboarding/user/${customerId}/business/${businessId}/ubo`;

  try {
    const { data } = await HttpService.post<{
      allowEditing: string;
      externalId: string;
      ownershipPercent: number;
    }>(url, body);
    setActiveUboName('', '');
    setGlobalCardName('', '');
    return data;
  } catch (error) {
    setActiveUboName('', '');
    setGlobalCardName('', '');
    throw error;
  }
};

export const getBusinessOwner = async (id: string) => {
  const businessExternalId =
    useBoundStore.getState().customer.customerData.customerBusinessData.externalId;
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/business/${businessExternalId}/ubo`
    : `v2/secureonboarding/user/${customerId}/business/${businessExternalId}/ubo`;

  const { data } = await HttpService.get<{ uboResponseList: UboResponse[] }>(url);
  const uboList = data?.uboResponseList;
  const ubo = uboList.find((owner) => owner.externalId === id);

  return ubo;
};

export const getBusinessOwnerQueryData = (id?: string) => ({
  queryKey: ['getBusinessOwnerQueryData', id],
  queryFn: () => (id ? getBusinessOwner(id) : null),
});
